import React from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, Typography } from '@mui/material'
import '../../../style/modal/Recharge.scss'
import DropDownV3 from '../../../common/DropDownV3'
import TextBox from '../../../common/TextBox'
import MButton from '../../../common/MButton'
import InfoCircleIcon from '../../../assets/Icons/InfoCircleIcon'
import QRTimer from '../../../common/QRTimer'
const Recharge = (props) => {
    const { open = false, titleText = '', onClose = () => { }, } = props
    const operatorProps = () => {
        return {
            width: "100%",
            name: "SelectOperator",
            id: 'SelectOperator',
            label: "Select Operator",
            isCompulsory: false,
            options: [],
            preSelectedValues: [],
            searchPlaceholder: "Search by Operator",
            disabled: false,
            isObject: true,
            primaryKey: 'id',
            labelKey: 'label',
            singleSelect: true,
            nextId: '',
            prevId: ``,

        }
    }
    return (
        <CustomizedDialogs
            open={open}
            titleText={titleText}
            width={'400px'}
            height={'auto'}
            onClose={onClose}
            padding={'0px'}
        >
            <Box className='recharge_page'>
                <Box className='filter_Section'>
                    <Box>
                        <DropDownV3
                            {...operatorProps()}
                            onSelect={() => { }}
                        />
                    </Box>
                    <Box>
                        <TextBox label='Enter Price' type='number' />
                    </Box>
                    <MButton btnName='generate QR' style={{ width: '100% !important' }} onClick={() => { }} />
                </Box>
                <Box className='scan_section'>
                    <Box className='header-text-section'>
                        <Typography sx={{ color: '#202020' }}>Scan to Pay</Typography>
                    </Box>
                    <Box className='time-section'>
                        <InfoCircleIcon />
                        <QRTimer onExpire={() => {

                        }} />
                    </Box>
                      <Box>
                    <div
                        id="qrCode"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundImage: `url(${''})`,
                            padding: '8px',
                            height: '187.39px',
                            width: '185px',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    />
                </Box>
                <Box className='image-section'>
                    <img src="./images/AppImage.png" alt="AppImage" srcset="" style={{
                        height: '20px'
                    }} />
                </Box>
                </Box>
            </Box>
        </CustomizedDialogs>
    )
}

export default Recharge